const GlobAttr = {
  primeColor: '#B9103D',
  inactiveColor: '#e0e0e0',
  white: '#FFFFFF',
  unHilight: '#757575'
}
export default GlobAttr
